import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-form"
export default class extends Controller {
  static targets = ["startsAt", "endsAt"]

  connect() {
    console.log("EventFormController connected")
  }

  // When starts_at changes, suggest the same datetime for ends_at if ends_at is empty
  suggestEndDate() {
    console.log("suggestEndDate called")
    
    const startsAtValue = this.startsAtTarget.value
    console.log("startsAtValue:", startsAtValue)
    console.log("endsAtTarget.value:", this.endsAtTarget.value)
    
    // Only suggest if starts_at has a value and ends_at is empty
    if (startsAtValue && !this.endsAtTarget.value) {
      console.log("Setting end date suggestion")
      
      console.log("Setting endsAtTarget.value to:", startsAtValue)
      this.endsAtTarget.value = startsAtValue
      console.log("endsAtTarget.value after setting:", this.endsAtTarget.value)
    } else {
      console.log("Conditions not met - not suggesting end date")
    }
  }
}
